import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";

import { LANGUAGE_CONFIG, IConfig } from "./language.tokens";
import { LanguageService } from "./language.service";

@NgModule({
  imports: [CommonModule]
})
export class LanguageModule {
  static forRoot(config: IConfig): ModuleWithProviders<LanguageModule> {
    return {
      ngModule: LanguageModule,
      providers: [
        LanguageService,
        {
          provide: LANGUAGE_CONFIG,
          useValue: config
        }
      ]
    };
  }
}
